import React from 'react'
import { Modal as RACModal, ModalOverlay, ModalOverlayProps } from 'react-aria-components'
import './Modal.css'
import { Button } from '../Button'

export function Modal(props: ModalOverlayProps) {
  return (
    <ModalOverlay isDismissable>
      <RACModal {...props} />
    </ModalOverlay>
  )
}

type ModalHeaderProps = {
  children: React.ReactNode
  onClose?(): void
}

export function ModalHeader({ children, onClose }: ModalHeaderProps) {
  return (
    <div className="ModalHeader">
      <h3 className="ModalHeader-title">{children}</h3>
      <button type="button" className="ModalHeader-close" aria-label="Close" onClick={onClose}>
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  )
}

type ModalContentProps = {
  children: React.ReactNode
  style?: React.CSSProperties
}

export function ModalContent({ style, children }: ModalContentProps) {
  return (
    <div className="ModalContent" style={style}>
      {children}
    </div>
  )
}

type ModalFooterProps = {
  children: React.ReactNode
  onClose?(): void
}

export function ModalFooter({ children, onClose }: ModalFooterProps) {
  return (
    <div className="ModalFooter">
      {onClose && <Button onPress={onClose}>Close</Button>}
      {children}
    </div>
  )
}
